import React from 'react';

const RouteHistory = ({ history, pets, drivers }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <h3 className="text-lg font-semibold mb-4">Historial de Rutas</h3>
      {history.length > 0 ? (
        <div className="space-y-3">
          {history.map((route) => {
            const driver = drivers.find(d => d.id === route.driverId);
            return (
              <div key={route.id} className="border-b border-gray-100 pb-3">
                <div className="flex justify-between items-center">
                  <div>
                    <h4 className="font-medium">{new Date(route.date).toLocaleDateString()}</h4>
                    <p className="text-sm text-gray-600">Conductor: {driver?.name}</p>
                  </div>
                  <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                    {route.stopsCompleted} mascotas
                  </span>
                </div>
                <div className="mt-2 flex space-x-2 overflow-x-auto pb-2">
                  {route.stops.map((stop, i) => {
                    const pet = pets.find(p => p.id === stop.petId);
                    return (
                      <span key={i} className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded-full whitespace-nowrap">
                        {pet?.name} ({stop.action === 'pickup' ? 'R' : 'E'})
                      </span>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-500 text-center py-4">No hay historial de rutas</p>
      )}
    </div>
  );
};

export default RouteHistory;